"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Autocomplete_1 = __importDefault(require("@mui/material/Autocomplete"));
var styles_1 = require("@mui/material/styles");
var prism_icons_1 = require("@octanner/prism-icons");
var TextField_1 = __importDefault(require("../TextField"));
var Chip_1 = __importDefault(require("../Chip"));
var AutoCompleteMultiSelectVariant_1 = __importDefault(require("../AutoCompleteMultiSelectVariant"));
var StyledAutocomplete = (0, styles_1.styled)(Autocomplete_1.default)({
    '& .MuiFilledInput-root': {
        '& .MuiFilledInput-input': {
            paddingLeft: '8px',
        },
        '& .MuiAutocomplete-clearIndicator': {
            visibility: 'visible',
        },
    },
}, {
    '& + .MuiAutocomplete-popper': {
        paddingTop: "4px",
        '& .MuiFilledInput-input': {
            paddingLeft: '8px',
        },
        '& .MuiAutocomplete-paper': {
            fontSize: '14px',
        },
        '.MuiAutocomplete-option': {
            fontSize: '14px',
        },
        '& .MuiAutocomplete-listbox': {
            '& .MuiAutocomplete-option': {
                borderBottom: '0px',
            },
        },
        '.MuiAutocomplete-groupUl': {
            borderRadius: '0px',
            padding: '0px 0px 8px 0px',
        },
        '.MuiListSubheader-root': {
            fontSize: '12px',
            maxHeight: '32px',
            lineHeight: '32px',
        },
        '.MuiAutocomplete-groupLabel': {
            paddingLeft: '16px',
        },
        "& .MuiAutocomplete-option[aria-selected='true']": {
            backgroundColor: '#DEEBFC',
            color: '#0060E0',
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
            '& .Mui-focused': {
                backgroundColor: '#DEEBFC',
            },
        },
        '.MuiAutocomplete-listbox > li': {
            borderBottom: '1px solid #C4C4C4',
            '&:last-child': {
                paddingTop: '8px',
                borderBottom: '0px',
            },
        },
        '.MuiAutocomplete-listbox > li:last-child > ul': {
            '&:last-child': {
                padding: "0px",
            },
        },
        '.MuiAutocomplete-listbox': {
            padding: '8px',
        },
        ".MuiAutocomplete-option[aria-selected='true'].Mui-focused": {
            backgroundColor: '#DEEBFC',
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
        },
    },
});
var Autocomplete = function (props) {
    var _a = props.multiple, multiple = _a === void 0 ? false : _a, options = props.options, label = props.label, groupBy = props.groupBy, getOptionLabel = props.getOptionLabel, renderOption = props.renderOption, sx = props.sx, onInputChange = props.onInputChange, inputValue = props.inputValue, onChange = props.onChange, classes = props.classes, _b = props.className, className = _b === void 0 ? '' : _b, style = props.style, defaultValue = props.defaultValue, loading = props.loading, getOptionSelected = props.getOptionSelected, required = props.required, error = props.error, helperText = props.helperText, id = props.id, noOptionsText = props.noOptionsText, open = props.open, onOpen = props.onOpen, onClose = props.onClose, fullWidth = props.fullWidth, renderInput = props.renderInput, _c = props.renderTags, renderTags = _c === void 0 ? function (value, getTagProps) {
        return value.map(function (option, index) { return (react_1.default.createElement(Chip_1.default, __assign({ size: 'small', label: getChipOptionLabel(option) }, getTagProps({ index: index })))); });
    } : _c, value = props.value, disabled = props.disabled, limitTags = props.limitTags, isOptionEqualToValue = props.isOptionEqualToValue, autoHighlight = props.autoHighlight, dataTestId = props["data-testid"], ListboxProps = props.ListboxProps, disableCloseOnSelect = props.disableCloseOnSelect, disableClearable = props.disableClearable, filterOptions = props.filterOptions, filterSelectedOptions = props.filterSelectedOptions, _d = props.getChipOptionLabel, getChipOptionLabel = _d === void 0 ? function (option) { return option.label || ''; } : _d, _e = props.disablePortal, disablePortal = _e === void 0 ? true : _e, _f = props.freeSolo, freeSolo = _f === void 0 ? false : _f, _g = props.clearOnBlur, clearOnBlur = _g === void 0 ? false : _g, ListboxComponent = props.ListboxComponent, PopperComponent = props.PopperComponent, _h = props.isMultiVariant, isMultiVariant = _h === void 0 ? false : _h, setValue = props.setValue, _j = props.labelId, labelId = _j === void 0 ? 'label' : _j, PaperComponent = props.PaperComponent;
    if (isMultiVariant) {
        return (react_1.default.createElement(AutoCompleteMultiSelectVariant_1.default, { value: value, setValue: setValue, options: options, label: label, disabled: disabled, inputValue: inputValue, onInputChange: onInputChange, error: error, helperText: helperText, labelId: labelId }));
    }
    return (react_1.default.createElement(StyledAutocomplete, { componentsProps: {
            clearIndicator: {
                tabIndex: 0,
            },
            popupIndicator: { tabIndex: 0 },
        }, limitTags: limitTags, className: className, id: id, clearIcon: react_1.default.createElement(prism_icons_1.Close, null), freeSolo: freeSolo, clearOnBlur: clearOnBlur, renderInput: renderInput
            ? renderInput
            : function (params) { return (react_1.default.createElement(TextField_1.default, __assign({ required: required, helperText: helperText, error: error, label: label }, params))); }, options: options, groupBy: groupBy, disablePortal: disablePortal, popupIcon: react_1.default.createElement(prism_icons_1.ArrowDown, null), multiple: multiple, renderTags: renderTags, getOptionLabel: getOptionLabel, renderOption: renderOption, sx: sx, onInputChange: onInputChange, inputValue: inputValue, onChange: onChange, classes: classes, style: style, defaultValue: defaultValue, loading: loading, getOptionSelected: getOptionSelected, required: required, noOptionsText: noOptionsText, open: open, onOpen: onOpen, onClose: onClose, fullWidth: fullWidth, value: value, PaperComponent: PaperComponent, disabled: disabled, isOptionEqualToValue: isOptionEqualToValue, autoHighlight: autoHighlight, ListboxProps: ListboxProps, "data-testid": dataTestId, disableCloseOnSelect: disableCloseOnSelect, disableClearable: disableClearable, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions, ListboxComponent: ListboxComponent, PopperComponent: PopperComponent }));
};
exports.default = Autocomplete;
__exportStar(require("@mui/material/Autocomplete"), exports);
//# sourceMappingURL=index.js.map